import { render, staticRenderFns } from "./userLaw1.vue?vue&type=template&id=019c6b4a&scoped=true&"
import script from "./userLaw1.vue?vue&type=script&lang=js&"
export * from "./userLaw1.vue?vue&type=script&lang=js&"
import style0 from "./userLaw1.vue?vue&type=style&index=0&id=019c6b4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c6b4a",
  null
  
)

export default component.exports